/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type StorefrontProductGrid_products$ref = any;
export type StorefrontFeaturedSection_products$ref = any;
export type StorefrontFeaturedSection_products = {
    readonly " $fragmentRefs": StorefrontProductGrid_products$ref;
    readonly " $refType": StorefrontFeaturedSection_products$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontFeaturedSection_products",
    "type": "DealerStorefrontQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "StorefrontProductGrid_products",
            "args": null
        }
    ]
} as any);
(node as any).hash = '2d2c8610c5ed41f25743180021d9d7ec';
export default node;
